import {useEffect, useState} from "react";
import _ from "lodash";

type Path = string | string[];

export function useBaseComponent<IBaseProps, IBaseState>(
    props: IBaseProps,
    methods: {
        initialState: (props: IBaseProps) => IBaseState;
        onInit?: () => void | Promise<void>;
    }
) {
    const [state, setState] = useState<IBaseState>(() => methods.initialState(props));

    // function updateState(path: Path, value: any) {
    //     setState(prevState => {
    //         const newState = window.structuredClone(prevState);
    //         _.set(newState, path, value);
    //         return newState as IBaseState;
    //     });
    // }

    function updateState(path: Path, value: any) {
        setState(prevState => {
            // shallow copy root
            const newState = { ...prevState } as IBaseState;
            // mutate the copy, not the original
            _.set(newState as object, path as any, value);
            return newState;
        });
    }

    useEffect(() => {
        methods.onInit?.();
    }, []);

    return {state, updateState};
}